export default {
    "layout_chi_siamo": "\u00fcber uns",
    "layout_orari": "Offnungszeiten",
    "layout_info": "Info",
    "layout_news": "Aktuelles",
    "layout_indirizzi_consegna": "Lieferadressen",
    "layout_notifiche": "Benachrichtigungen",
    "layout_impostazioni": "Einstellungen",
    "layout_login": "Anmelden",
    "layout_logout": "Abmelden",
    "layout_privacy": "Datenschutzerklärung",
    "layout_fidelity_card": "Fidelity-Karte",
    "layout_prenota_tooltip": "Tisch reservieren",
    "layout_carrello_tooltip": "Warenkorb",
    "layout_profilo_tooltip": "Benutzerkonto",
    "layout_domanda_titolo": "WANN WILLST DU ESSEN?",
    "layout_opzioni_label": "BESTELLOPTIONEN",
    "layout_opzioni_label_csconto_tooltip": "Rabattcodes",
    "impostazioni_lingue": "Sprachen",
    "impostazioni_notifiche": "Push-Benachrichtigungen",
    "impostazioni_ordini": "Bestellungen und Reservierungen",
    "impostazioni_ordini_txt": "Benachrichtigungen zum Status von Bestellungen und Reservierungen",
    "impostazioni_sconto": "Neuigkeiten und Rabattcodes",
    "impostazioni_sconto_txt": "Benachrichtigungen zu Neuigkeiten und Rabattcodes",
    "impostazioni_suggerimenti": "Aktivitäten und Empfehlungen",
    "impostazioni_suggerimenti_txt": "Auf Ihre Aktivitäten zugeschnittene Benachrichtigungen",
    "impostazioni_sempre": "Immer",
    "impostazioni_attive": "Aktiv",
    "impostazioni_login_required": "Melden Sie sich an, um Benachrichtigungen zu verwalten.",
    "impostazioni_si": "Ja",
    "impostazioni_no": "Nein",
    "notifiche_valido_tutti_locali": "Gültig in allen Filialen",
    "notifiche_valido_locali": "Gültig in den Filialen:",
    "index_ordine_titolo": "WO WILLST DU BESTELLEN?",
    "ristorante_benvenuto": "Willkommen am",
    "ristorante_consulta": "Konsultieren Sie unser Men\u00fc und geben Sie Ihre Bestellung auf",
    "ristorante_prenota": "B\u00fcchen Sie Ihren Tisch in unserem Restaurant.",
    "ristorante_sondaggio": "Umfrage",
    "ristorante_ordina_btn": "jetzt bestellen",
    "ristorante_prenota_btn": "Jetzt buchen",
    "ristorante_presentiamo_titolo": "wir stellen uns vor",
    "ristorante_continua_lettura_btn": "Lesen Sie weiter",
    "ristorante_novita_titolo": "neueste Nachrichten",
    "ristorante_novita-vedi_btn": "Alle Nachrichten sehen",
    "ristorante_orario_titolo": "wann Sie uns finden",
    "ristorante_chiusure_title": "nächste Schlie\u00dfungen",
    "ristorante_contatti_titolo": "um uns zu kontaktieren",
    "ristorante_dettaglio_titolo": "wir stellen uns vor...",
    "confermato": "Bestätigen",
    "rifiutato": "Abgelehnt",
    "attesa": "Warten",
    "annullato": "Storniert",
    "ordine_appena_possibile": "so schnell wie m\u00f6glich",
    "ordine_n_persone": "Wählen Sie die Anzahl der Personen",
    "ordine_titolo": "jetzt bestellen",
    "ordine_scelta_titolo": "Wählen Sie den Typ",
    "ordine_scelta_data_titolo": "Wähle das Datum",
    "ordine_scelta_orario_titolo": "wähle die Zeit",
    "ordine_menu_btn": "Men\u00fc",
    "ordine_salva_ordine_btn": "zur Bestellung hinzuf\u00fcgen",
    "ordine_dettaglio": "Bestelldetail",
    "ordine_numero": "Bestellnummer",
    "ordine_annulla_msg": "Wenn Sie die Bestellung stornieren m\u00f6chten, wenden Sie sich bitte telefonisch an den \u00f6rtlichen Händler",
    "ordine_torna_storico": "Gehen Sie zur\u00fcck zur Geschichte",
    "ordine_tempo_esaurito_label": "Die Zeit, die Ihnen zur Verf\u00fcgung steht, um die Bestellung abzuschlie\u00dfen, ist abgelaufen. Wählen Sie ein neues Zeitfenster.",
    "ordine_posti_esauriti_label": "Es gibt keine Orte f\u00fcr das ausgewählte Zeitfenster",
    "ordine_scegli_orario_label": "wähle die Zeit",
    "ordine_opzioni": "wähle die Zeit",
    "ordine_inviato": "Bestellung erfolgreich gesendet",
    "ordine_riepilogo": "Bestell\u00fcbersicht",
    "ordine_consegna_id": "Lieferung in",
    "ordine_fatturare_a": "Rechnung ",
    "ordine_consegna": "Lieferung",
    "ordine_sconto": "Rabattcode",
    "ordine_sconto_errato": "falscher Code",
    "ordine_sconto_invalido": "Ung\u00fcltiger Rabattcode f\u00fcr diesen lokalen",
    "ordine_sconto_applicato": "Rabatt angewendet",
    "ordine_storico": "Bestellhistorie",
    "ordini_effettuati": "Bestellungen aufgegeben",
    "ordini_pagamento": "Zahlung",
    "ordini_riepilogo_label": "Auftragsbestätigung",
    "": "Bestellung",
    "ordini_data": "aufgegeben am",
    "ordini_ritiro_label": "Abholung in unserem Restaurant am",
    "ordini_ore": "um",
    "ordini_ordine": "Bestellen",
    "ordini_consegna_giorno": "Lieferung geplant f\u00fcr Tag",
    "ordini_consegna_fascia": "im Zeitfenster",
    "ordini_consegna_indirizzo": "unter der folgenden Adresse geplant",
    "ordini_fatturare_nome": "Rechnung",
    "ordini_note": "Bestellhinweise",
    "ordini_totale": "Gesamtbestellung",
    "ordine_riepilogativa": "Diese E-Mail ist eine Zusammenfassung der gerade getätigten Bestellung",
    "ordine_dettagli": "Alle Bestelldetails finden Sie im Abschnitt Bestellverlauf der App",
    "ordine_dettagli_ridotto": "Alle Bestelldetails finden Sie im Abschnitt Bestellverlauf der App",
    "ordine_clicca_dettagli": "oder klicken Sie unten auf Bestelldetails",
    "ordine_dettagli_label": "Bestelldetails",
    "ordine.prezzo_minimo_no": "Um fortzufahren, m\u00fcssen Sie mindestens",
    "ordine.ingredienti": "Zutaten",
    "ordine.allergeni": "Allergene",
    "ordine.aggiunte": "Extra",
    "ordine.nessuna_aggiunta_disponibile": "Keine Extras verf\u00fcgbar",
    "ordine.bloccati_msg": "vor\u00fcbergehend gesperrte Bestellungen",
    "ordine.seleziona_aggiunte": "Wählen Sie die gew\u00fcnschten Extras aus",
    "ordine.dettagli_allergeni": "Allergendetails",
    "ordine.allergeni_contenuti_label": "Die im ausgewählten Produkt enthaltenen Allergene sind nachstehend aufgef\u00fchrt",
    "ordine.allergeni_informazioni_text": "Diese Informationen beziehen sich auf die 14 wichtigsten Allergene nach geltenden Vorschriften (mit Ausnahme der Zutaten, die von der Vorschrift ausgeschlossen sind). Die Informationen wurden anhand der Daten erstellt, die uns unsere Lieferanten \u00fcber die Zusammensetzung ihrer Produkte und die in den Produkte verarbeiteten Zutaten geliefert haben. Es kann dennoch nicht ausgeschlossen werden, dass die Produkte Spuren enthalten von.<br>\n        Die Zusammensetzung der Produkte kann sich ändern. Wir werden unser Bestes tun, um dies zu aktualisieren Abschnitt, insbesondere wenn wir \u00fcber die \u00c4nderung der Zusammensetzung eines dieser informiert werden. Wir laden Sie ein diesen Abschnitt regelmä\u00dfig zu besuchen und die verschiedenen Elemente dieses Abschnitts Ihrem Arzt oder Ihrem Arzt vorzustellen Allergiker, damit er Sie bei der Auswahl der Lebensmittel beraten kann.",
    "ordine.grazie_ok": "Danke, ich verstehe",
    "ordine.leggenda_informazioni": "Informationslegende",
    "ordine.misura": "Grösse auswählen",
    "ordine.misura_sel": "Wählen Sie die gew\u00fcnschte Gr\u00f6\u00dfe",
    "ordine.variante_titolo": "Varianten",
    "ordine.variante_sel": "Wählen Sie die gew\u00fcnschte Variante",
    "ordine.scegli": "Sie müssen Produkte mit einer Mindestmenge von auswählen",

    "carrello_importo_indicativo": "Der Betrag ist indikativ. Der tatsächliche Betrag wird angewendet, sobald die Lieferadresse eingegeben oder bestätigt wurde.",
    "carrello_tempo_disponibile": "Wenn Sie auf \"Weiter\" klicken, haben Sie 15 Minuten Zeit, um die Bestellung abzuschlie\u00dfen und die ausgewählten Datums- und Uhrzeitoptionen sicherzustellen.",
    "carrello_avviso_spese_consegna": "Die Versandkosten werden berechnet, indem Sie mit der Einstellung fortfahren.",
    "carrello_ordine_label": "bestellen",
    "carrello_indirizzo_consegna": "Lieferadresse",
    "carrello_predefinito": "default",
    "carrello_mod_pagamento": "Zahlungsmethoden",
    "prenota_mod_pagamento": "Wählen Zahlungsmethoden",
    "carrello_mezzo_pagamento": "Wie bezahlen Sie bei Abholung \/ Lieferung?",
    "carrello_pag_contanti_ritiro": "beim R\u00fcckzug",
    "carrello_pag_contanti_consegna": "bei Lieferung",
    "carrello_pag_buoni_pasto": "Essensgutscheine",
    "carrello_pag_carte": "Kreditkarte",
    "carta_di_credito_consegna": "Bei Lieferung per Debit oder Karte",
    "carta_di_credito_ritiro": "Bei Abhebung per Debit oder Karte",
    "carrello_pag_bancomat": "Geldautomat ",
    "carrello_richiedi_fattura": "Eine Rechnung anfordern",
    "carrello_riepilogo": "Warenkorb Zusammenfassung",
    "carrello_sconto": "Verwenden Rabattcode",
    "carrello_premio": "Verwenden Prämie",
    "carrello_ins_sconto": "Geben Sie den Rabattcode hier ein",
    "carrello_appl_sconto": "Rabattcode anwenden",
    "carrello_appl_sconto_dett": "Der Rabatt gilt nur f\u00fcr Produkte ohne Versandkosten.",
    "carrello_note_generali": "Allgemeine Bestellhinweise",
    "carrello_ord_del": "Bestellung stornieren",
    "carrello_ord_conf": "Bestellung bestätigen",
    "carrello_vai_pagamento": "ZUR ZAHLUNG",
    "carrello_completa_ordine": "BESTELLUNG ABSCHLIESSEN",
    "carrello_sel_ind_title": "Adresse auswählen",
    "carrello_sel_ind_label": "Wählen Sie die Adresse aus, an die die Lieferung erfolgen soll",
    "carrello_ind_predefinito": "Als Standardadresse verwenden",
    "carrello_no_ind_consegna": "KEINE KONFIGURIERTE LIEFERADRESSE",
    "carrello.messaggio_alert_indirizzo": "KEINE AUSGEW\u00c4HLTE LIEFERADRESSE",
    "carrello.messaggio_alert_fattura": "KEINE AUSGEW\u00c4HLTE RECHNUNGSADRESSE",
    "carrello.indicazione_fattura": "Geben Sie eine Rechnungsadresse ein, indem Sie auf den Stift an der Seite klicken",
    "carrello.prd_aggiunto": "Produkt in den Warenkorb gelegt",
    "carrello.ingrediente_esaurito": "F\u00fcr dieses Produkt die folgenden Zutaten",
    "carrello.ingrediente_esaurito2": "vor\u00fcbergehend nicht vorrätig. Sie k\u00f6nnen es weiterhin bestellen und angeben, ob Sie alternativ einen Zusatz w\u00fcnschen.",
    "carrello.sconto_ordine_min_mag": "Um diesen Rabattcode verwenden zu k\u00f6nnen, muss die Mindestbestellmenge sein",
    "carrello.escluse_spese_spedizione": "ohne Versandkosten",
    "carrello.codice_sconto_usato": "Der Rabattcode wurde bereits f\u00fcr die maximal zulässige Anzahl von Malen verwendet",
    "carrello.quantita": "Menge",
    "carrello.prd_non_disponibili_msg": "Warnung: Einige Produkte sind m\u00f6glicherweise nicht im neu ausgewählten Zeitfenster verf\u00fcgbar. Sie werden aus dem Warenkorb entfernt",
    "carrello.scadenza_carrello": "Warenkorb läuft ab",
    "carrello.scadenza_minuti": "minuten",
    "carrello.rimangono_min": "Sie haben noch",
    "carrello.disponibilita_non_garantita": "Um die Bestellung abzuschlie\u00dfen, k\u00f6nnen wir die Verf\u00fcgbarkeit f\u00fcr das ausgewählte Datum und die ausgewählte Uhrzeit nicht garantieren.",
    "account.dati_utente": "Benutzerdaten",
    "account.gestione_indirizzi": "Adressverwaltung",
    "account.gestione_indirizzi_fatt": "Rechnungsadresse",
    "account.storico_ordini": "Bestellhistorie",
    "account.prenotazioni": "Buchung",
    "account.dati_registrazione": "Registrierungsdaten",
    "account.termini_condizioni": "Allgemeine Geschäftsbedingungen",
    "account.nuovo_indirizzo_consegna": "Neue Lieferadresse",
    "account.campanello": "T\u00fcrklingel",
    "account.indirizzo_fatturazione": "Rechnungsadresse",
    "account.mod_indirizzo_fatturazione": "Rechnungsadresse ändern",
    "account.accedi_dati": "Melden Sie sich mit Ihren Daten an",
    "account.nome_utente": "Benutzername",
    "account.password.dimenticata": "Sie haben Ihr Passwort vergessen",
    "account.accedi": "Zugang",
    "account.usr_no_mod": "Aus Sicherheitsgr\u00fcnden kann der Benutzername nicht geändert werden",
    "account.no_registrato": "Sie sind nicht registriert",
    "account.prosegui_ospite": "weiter als Gast",
    "account.registrazione": "Anmeldung",
    "account.dati_account": "Kontodaten",
    "account.conf_password": "Passwort wiederholen",
    "account.msg_conf_password_err": "Die beiden Passw\u00f6rter stimmen nicht \u00fcberein",
    "account.inserire_indirizzo_domanda": "Sie m\u00f6chten eine Lieferadresse eingeben",
    "account.via": "Stra\u00dfe",
    "account.civico": "Hausnummer",
    "account.sel_city": "Ort auswählen",
    "account.sel_country": "Wählen Sie das Land aus",
    "account.sel_cap": "Wählen Sie die PLZ",
    "account.inserire_ind_fat_domanda": "Sie m\u00f6chten eine Rechnungsadresse eingeben",
    "account.reg_soc": "Firma",
    "account.citta": "Ort",
    "account.prv": "Provinz",
    "account.cap": "Cap",
    "account.stato": "Land",
    "account.acc_termini": "Akzeptieren Sie die Allgemeinen Geschäftsbedingungen",
    "account.registrarti": "registrieren",
    "account.registrazione_ok": "Die Registrierung war erfolgreich",
    "account.save_ok": "Daten wurden erfolgreich geändert",
    "account.effettua_login": "Melden Sie sich an",
    "account.recupera_password": "Stellen Sie Ihr Passwort wieder her",
    "account.mail_recupera_inviata": "Die Anfrage wurde erfolgreich gesendet",
    "account.ins_utente_rec_password": "Geben Sie Ihr Benutzerkonto ein, um Kennw\u00f6rter wiederherzustellen",
    "account.recupera_btn": "Stellen Sie Ihr Passwort wieder her",
    "account.recupera_controlla_mail": "\u00dcberpr\u00fcfen Sie Ihre E-Mails, auch im Spam-Ordner. Wir haben Ihnen die Anmeldeinformationen f\u00fcr den Zugriff auf den Dienst gesendet",
    "account.mail.recupera_psw.uno": "Sehr geehrter Kunde",
    "account.mail.recupera_psw.due": "Klicken Sie auf den folgenden Link, um ein neues Passwort f\u00fcr Ihr Konto festzulegen ",
    "account.mail.recupera_psw.tre": "Das Kuokko-Personal",
    "account.nuova_password_ind": "Geben Sie das neue Passwort ein",
    "account.nuova_password_label": "Legen Sie ein neues Passwort fest",
    "account.account_non_trovato": "Konto nicht gefunden",
    "account.campo_obbligatorio": "Es ist ein Pflichtfeld",
    "account.psw_coincidenti": "Passwort und Wiederholungspasswort m\u00fcssen \u00fcbereinstimmen",
    "account.termini_condizioni_msg": "Um fortzufahren, m\u00fcssen Sie die Allgemeinen Geschäftsbedingungen akzeptieren",
    "account.acc_privacy_msg": "Um fortzufahren, m\u00fcssen Sie die Privatsphäre akzeptieren",
    "account.cntr_spam_msg": "\u00dcberpr\u00fcfen Sie Ihre E-Mails, auch im Spam-Ordner. Wir haben Ihnen die Anmeldeinformationen f\u00fcr den Zugriff auf den Dienst gesendet",
    "account.cliente_non_trovato": "Client nicht gefunden",
    "account.apikey_non_trovata": "Api Key nicht gefunden",
    "account.indirizzo_non_trovato": "Adresse nicht gefunden",
    "account.account": "Account",
    "account.delete_title": "Konto löschen",
    "account.delete_warning": "Achtung, Sie sind dabei, Ihr Benutzerkonto zu löschen.",
    "account.delete_description": "Wenn Sie fortfahren, werden Ihre Daten gelöscht und können nicht wiederhergestellt werden. Wenn Sie in Zukunft erneut bestellen oder die App nutzen möchten, müssen Sie sich neu registrieren.",
    "account.delete_confirm": "Konto löschen",
    "prenotazione.storico": "Buchungsverlauf",
    "prenotazione.effettuate": "Reservierungen gemacht",
    "prenotazione.dettagli": "Buchungsdetail",
    "prenotazione": "Buchung",
    "prenotazione.status": "Status",
    "prenotazione.riferimento": "Referenz",
    "prenotazione.annulla": "Reservierung stornieren",
    "prenotazione.info_annulla": "Um Ihre Reservierung zu stornieren oder zu ändern, bitten wir Sie, das Restaurant direkt telefonisch zu kontaktieren",
    "prenotazione_tavolo.richiesta": "Tischreservierung Anfrage",
    "prenotazione_tavolo.tavolo_per": "Buchen Sie einen Tisch f\u00fcr",
    "prenotazione_tavolo.dati": "personenbezogene Daten",
    "prenotazione_tavolo.privacy": "Akzeptanz der Privatsphäre",
    "prenotazione_tavolo.privacy.informativa": "Lesen Sie die Informationen",
    "prenotazione_tavolo.submit_btn": "B\u00fcchertisch",
    "prenotazione_tavolo.richiesta_inviata": "Die Buchungsanfrage wurde gesendet.",
    "prenotazione_tavolo.richiesta_confermata": "Die Buchungsanfrage wurde bestätigt.",
    "prenotazione_tavolo.attendi_conferma": "Warten Sie auf eine Bestätigung unserer Mitarbeiter!",
    "prenotazione_tavolo.ti_aspettiamo": "Wir warten auf dich!",
    "prenotazione_tavolo.augurio": "Gute Fortsetzung",
    "prenotazione_tavolo.torna_home": "Gehen Sie zur\u00fcck zur Startseite",
    "prenotazione_tavolo.precedente": "fr\u00fcher",
    "prenotazione_tavolo.successivo": "folgende",
    "prenotazione_tavolo.torna_lista": "Zur\u00fcck zur Liste",
    "prenotazioni_tavolo.bloccate": "Reservierungen vor\u00fcbergehend gesperrt",
    "prenotazioni_tavolo.nessuna": "Keine Reservierungen gemacht",
    "prenotazioni_tavolo.persona": "Person | Leute",
    "prenotazioni_tavolo.persone": "Leute",
    "allergeni.glutine": "Gluten",
    "allergeni.crostacei": "Schaltier",
    "allergeni.uova": "Eier",
    "allergeni.pesce": "Fisch",
    "allergeni.arachidi": "Erdn\u00fcsse",
    "allergeni.soia": "Soja",
    "allergeni.latte": "Milch",
    "allergeni.fruttasecca": "Trockenfr\u00fcchte",
    "allergeni.sedano": "Sellerie",
    "allergeni.senape": "Senf",
    "allergeni.sesamo": "Sesam",
    "allergeni.molluschi": "Mollusken",
    "allergeni.cereali": "Getreide",
    "allergeni.so2": "Schwefeldioxid",
    "news.rimani_aggiornato": "Bleiben Sie auf dem Laufenden",
    "news.lista": "Nachrichtenliste",
    "news.leggi": "Gesetze",
    "sconti.lista_title": "Liste der aktiven Rabattcodes",
    "sconti.ordine_minimo": "Mindestbestellmenge",
    "termini_condizioni.titolo": "Nutzungsbedingungen (nur in italienischer Sprache)",
    "termini_condizioni.testo": "KUOKKO ti da il benvenuto!<br>\n        Siamo davvero entusiasti che tu abbia deciso di accedere ed utilizzare i Servizi costituiti dalla nostra piattaforma per gli ordini online, a cui si accede tramite il sito web e le applicazioni KUOKKO per conto dei nostri clienti Ristoranti.<br><br>\n        I presenti Termini e Condizioni d\u2019Uso costituiscono l'accordo tra te (Utente), il Ristorante indicato nei Servizi ed Agaweb srl Unipersonale (Agaweb) societ\u00e0 proprietaria, gestore ed erogatore del Servizio KUOKKO. Disciplinano l'utilizzo dell\u2019applicazione mobile, della web app, dei relativi software e servizi, prenotazioni dei tavoli, commercio a distanza, promozioni e notifiche push (di seguito \u201cServizi\u201d). Prima di utilizzare i Servizi ti invitiamo a leggere i Termini e Condizioni d\u2019Uso ed ad accettarli solo ove compresi e condivisi.<br><br>\n        \n        <b>Utente e responsabilit\u00e0<\/b><br>\n        Per Utente si intende la persona fisica che utilizza i Servizi per scopi personali che ha compiuto la maggiore et\u00e0 e che possiede la capacit\u00e0 di agire (conformemente all\u2019art. 2 del codice civile italiano). L\u2019Utente \u00e8 responsabile per gli ordini, le prenotazioni e le altre azioni effettuate attraverso i Servizi. Le eventuali offerte sulle bevande alcoliche sono riservate esclusivamente agli Utenti maggiorenni. Ogni utente \u00e8 responsabile degli alimenti ordinati e consumati, con particolare riferimento ad eventuali intolleranze o allergie. <br><br>\n        \n        <b>Ristorante<\/b><br>\n        Per Ristorante si intende l\u2019esercizio commerciale indicato nei Servizi presso il quale effettuare gli ordini take away o delivery, le prenotazioni dei tavoli e dal quale ricevere notifiche push e promozioni.<br><br>\n        \n        <b>Agaweb srl Unipersonale<\/b><br>\n        Agaweb srl Unipersonale \u00e8 la societ\u00e0 ideatrice, proprietaria e gestore dei Servizi KUOKKO nonch\u00e9 proprietaria del marchio Kuokko.<br><br>\n        \n        <b>Descrizione del servizio<\/b><br>\n        Kuokko \u00e8 una piattaforma di ultima generazione per gli ordini online che utilizza le pi\u00f9 recenti tecnologie web e mobile per consentirti di ordinare dal Ristorante e molto altro ancora.<br>\n        Kuokko non vende i prodotti contenuti nel tuo ordine, non \u00e8 parte di tali transazioni e non ha alcun controllo sulla qualit\u00e0 o sicurezza dei prodotti. Il tuo ordine \u00e8 tra te (Utente) e il Ristorante dal quale ordini. <br>\n        Il ristorante pu\u00f2 dichiarare gli ingredienti o rappresentare gli allergeni o gli standard di preparazione dei cibi attraverso i Servizi, come ad esempio cibo o bevande che non contengono noci, senza glutine, senza lattosio, biologici o altro. Non esaminiamo n\u00e9 verifichiamo i menu, gli ingredienti, gli standard di preparazione del cibo o eventuali descrizioni o dichiarazioni fatte dai ristoranti.<br> \n        Pertanto, se tu o chiunque consumi un pasto, ingrediente o un qualsiasi altro articolo ordinato tramite i Servizi, ha qualche allergia alimentare o requisiti specifici di preparazione, ti consigliamo vivamente di contattare direttamente il ristorante per soddisfare le tue specifiche esigenze. <br><br>\n        Utilizzando i Servizi, accetti che Kuokko non \u00e8 responsabile per dichiarazioni o omissioni relative ai prodotti contenuti nel tuo ordine. Forniamo ai visitatori e agli utenti registrati l'accesso ai servizi come descritto nel presente accordo.<br><br>\n        &bull; Visitatori. Nessun accesso \u00e8 richiesto per i visitatori dei Servizi. I visitatori possono (a) visualizzare tutti i contenuti accessibili al pubblico, (b) inviarci un'e-mail.<br><br>\n        &bull; Utenti registrati. Il login \u00e8 richiesto per tutti i servizi per utenti registrati. Gli utenti registrati possono fare tutto ci\u00f2 che i visitatori possono fare, e anche (a) effettuare ordini, (b) richiedere una prenotazione, (c) utilizzare codici sconto riservati, (d) ricevere avvisi e altre notifiche.<br><br>\n        Kuokko non ha alcun obbligo di accettare alcun individuo come Utente Registrato e pu\u00f2 accettare o rifiutare qualsiasi registrazione a sua sola e completa discrezione.<br><br>\n        \n        <b>Come effettuare un ordine take away, delivery o una prenotazione<\/b><br>\n        Se non effettui la registrazione, puoi visualizzare il menu senza concludere l\u2019ordine e inviare una richiesta di prenotazione inserendo manualmente i tuoi dati di contatto. Per effettuare un ordine take-away o delivery e gli altri Servizi per utenti registrati, \u00e8 necessario effettuare la registrazione. Le credenziali dovranno essere mantenute riservate ed ogni utente \u00e8 responsabile della riservatezza di tali dati. <br>\n        Per effettuare un ordine take away o delivery devi registrarti ed effettuare il log-in. Di seguito potrai scegliere il giorno e l\u2019ora in cui desideri usufruire del servizio e aggiungere i piatti al tuo carrello. Dopo avere completato la scelta del servizio e confermato l\u2019ordine,  quest\u2019ultimo verr\u00e0 processato per il completamento. Riceverai una e-mail o altro tipo di notifica che ti dar\u00e0 conferma del buon fine dell\u2019ordine e riepilogo.<br>\n        Per effettuare una prenotazione puoi effettuare il log-in per evitare di inserire i tuoi dati. Se non effettui il log-in dovrai inserire i tuoi dati manualmente. Di seguito potrai scegliere data, ora e numero di persone che desiderano usufruire del servizio. Riceverai una e-mail o altro tipo di notifica che ti dar\u00e0 conferma o meno del buon fine della prenotazione.<br><br>\n        \n        <b>Mancata esecuzione dell'ordine<\/b><br>\n        In tutti i casi in cui l\u2019ordine non venga processato nessuna responsabilit\u00e0 potr\u00e0 essere attribuita al Ristorante o ad Agaweb. In ogni caso l\u2019eventuale responsabilit\u00e0 del Ristorante \u00e8 da intendersi limitata entro il valore dell\u2019ordine.<br><br>\n        \n        <b>Cancellazione dell'ordine<\/b><br>\n        Per la cancellazione dell\u2019ordine \u00e8 necessario contattare il Ristorante e concordare direttamente le modalit\u00e0.<br><br>\n        \n        <b>Pagamenti<\/b><br>\n        L\u2019Utente pu\u00f2 pagare il proprio ordine o Servizio direttamente al ritiro in Ristorante o alla consegna. Pertanto il pagamento \u00e8 regolamentato direttamente con il Ristorante.<br><br> \n        \n        <b>Sconti e promozioni<\/b><br>\n        Gli eventuali sconti verranno effettuati dal Ristorante che potr\u00e0 crearli in base alle proprie esigenze. Lo sconto avr\u00e0 la durata e l\u2019importo o la percentuale che di volta in volta il Ristorante indicher\u00e0.<br><br>\n        \n        <b>Funzionamento dei Servizi<\/b><br>\n        I Sistemi vengono erogati attraverso gli store Apple e Google. Nessuna responsabilit\u00e0 potr\u00e0 essere attribuita al Ristorante o ad Agaweb in caso di sospensione, modifica o cessazione del servizio da parte di Apple o Google. Apple o Google e il Ristorante o Agaweb sono quattro soggetti giuridici distinti ed indipendenti. Il Ristorante e Agaweb non potranno essere ritenuti responsabili nei confronti dell'Utente per il cattivo funzionamento e\/o l\u2019interruzione dell\u2019operativit\u00e0 dei Servizi, anche per brevi periodi, dovuto ad inconvenienti tecnici hardware, dei software e\/o delle linee di trasmissione e di accesso alla rete o dovuti a caso fortuito, forza maggiore o fatto imputabile a terzi.<br><br>        \n        \n        <b>Efficacia delle condizioni d'uso<\/b><br>\n        Il Ristorante non garantisce che i contenuti dei Servizi siano appropriati o leciti in paesi differenti dall\u2019Italia. L\u2019eventuale invalidit\u00e0, nullit\u00e0 o inefficacia di uno o pi\u00f9 clausole delle presenti Condizioni D\u2019Uso non determiner\u00e0 l\u2019invalidit\u00e0, inefficacia o nullit\u00e0 delle restanti clausole che resteranno valide ed efficaci.<br><br>\n        \n        <b>Modifica delle condizioni d'uso<\/b><br>\n        Il Ristorante tramite Agaweb potr\u00e0 richiedere all\u2019Utente di accettare, di volta in volta, ulteriori condizioni applicabili a parti specifiche o sezioni dell\u2019APP. Tali condizioni ulteriori saranno immesse nelle parti dell\u2019APP a cui si riferiscono e saranno chiaramente identificabili. Il Ristorante tramite Agaweb potr\u00e0 modificare le Condizioni D\u2019Uso le quali saranno applicabili a seguito della pubblicazione online e accettate con l\u2019utilizzo dell\u2019APP.<br><br>\n        \n        <b>Lingua e legge applicabile<\/b><br>\n        La legge che disciplina le Condizioni D\u2019Uso \u00e8 la legge italiana. Il presente accordo \u00e8 stato redatto in lingua italiana.<br>\n        Qualsiasi controversia che dovesse derivare dal rapporto regolato dal presente accordo \u00e8 di competenza esclusiva della giurisdizione ordinaria italiana.<br>",
    "note_generali_label": "Allgemeine Bemerkungen",
    "btn_salva": "Speichern",
    "totale": "Gesamt",
    "dettagli": "Details",
    "btn_annulla": "Stornieren",
    "btn_conferma": "Bestätigen",
    "btn_applica": "Anwenden",
    "btn_modifica": "Menge",
    "btn_elimina": "Eliminiert",
    "btn_indietro": "zur\u00fcck",
    "attenzione_label": "Achtung",
    "nome": "Vorname",
    "cognome": "Nachname",
    "email": "Email",
    "telefono": "Telefon",
    "chiudi": "Schlie\u00dfen",
    "sito_manutenzione": "Website unter Wartung",
    "zona": "Zone",
    "vai_alle": "oder gehen zu",
    "cod_fisc": "Steuerkennzeichen",
    "piva": "USt-IDNr.",
    "note": "Hinweise",
    "prosegui": "fortsetzen",
    "carrello_vuoto": "LEEREN CART",
    "allergeni_contenuti": "Allergene enthalten oder vorhanden sein:",
    "varianti": "varianten",
    "gusto": "Wahl",
    "gusti": "Entscheidungen",
    "agg_ingr": "Zutaten hinzuf\u00fcgen",
    "nessuna": "keiner",
    "scarica_app": "F\u00fcr eine bessere Erfahrung und Fluidität<br>\n\t\t\t\t\tladen Sie bitte unsere App herunter.<br>\n\t\t\t\t\tVerf\u00fcgbar im AppStore und bei Google Play. <br>\n\t\t\t\t\tDank!",
    "menu": "Men\u00fc",
    "nessuna_variante": "Keine Variante",
    "aggiungi": "hinzuf\u00fcgen",
    "sconto": "Rabatt",
    "nessun_ordine": "Keine Bestellung aufgegeben",
    "messaggio_locale": "Lokale Nachricht",
    "chiuso": "geschlossen",
    "sempre_valido": "Immer g\u00fcltig",
    "prenotazione_nuova": "Neu",
    "prenotazione_attesa": "Warten",
    "prenotazione_annullata": "storniert",
    "prenotazione_rifiutata": "abgelehnt",
    "prenotazione_confermata": "bestätigt",
    "carrello.codice_sconto_nonattivo": "Rabattcode nicht aktiv",
    "ore": "Stunden",
    "aggiunta": "Hinzuf\u00fcgen",
    "qta": "Menge",
    "select_order_type": "Wählen Sie die Art der Bestellung aus den oben aufgef\u00fchrten aus, um das Datum auszuwählen und das Men\u00fc anzuzeigen.",
    "eat_at_restaurant": "Vorbestellung",
    "al_tavolo": "am Tisch",
    "takeaway": "take away",
    "delivery": "Delivery",
    "type_message_here": "Schreiben Sie hier Ihre Nachricht",
    "mangia_tavolo_label": "Essen Sie am f\u00fcr den Tag geplanten Tisch",
    "contanti": "Bargeld",
    "precalculated_fidelity_points_1": "Mit dieser Bestellung sammeln Sie",
    "precalculated_fidelity_points_2": "Punkte. Die Punkte werden am Abhol- \/ Liefertermin auf Ihrer Kundenkarte angezeigt.",
    "address_management_changed": "Adressverwaltung geändert. Die Adresse muss gel\u00f6scht und neu erstellt werden",
    "fidelity_card_ad_home_c1": "Bisher haben Sie",
    "punti": "Punkte gesammelt",
    "dal": "von",
    "al": "bis",
    "fidelity_card_accumulato": "Sie haben angesammelt",
    "fidelity_card_raccogli_1": "collect",
    "fidelity_card_raccogli_2": "Punkte, um diese Auszeichnung zu erhalten",
    "fidelity_card_punti_regola_1_1": "Die Punkte werden aktualisiert, wenn die Bestellung verbraucht ist (Datum / Uhrzeit der Abholung oder Lieferung).",
    "fidelity_card_punti_regola_1_2": "Belohnungen werden automatisch angesammelt, wenn die erforderliche Punkteschwelle erreicht ist.",
    "fidelity_card_punti_regola_1_3": "Die Gesamtpunktzahl wird zurückgesetzt, wenn die maximale Punktzahl erreicht ist.",
    "fidelity_card_punti_regola_1_4": "Wenn Sie eine Belohnung in einer Bestellung verwenden, wird sie aus der Belohnungsliste gelöscht.",
    "fidelity_card_punti_regola_2_1": "Die Punkte werden aktualisiert, wenn die Bestellung verbraucht ist (Datum / Uhrzeit der Abholung oder Lieferung).",
    "fidelity_card_punti_regola_2_2": "Belohnungen können ausgewählt werden, sobald der erforderliche Punkteschwellenwert erreicht wurde.",
    "fidelity_card_punti_regola_2_3": "Die Punktzahl wird nicht zurückgesetzt, sondern wächst mit nachfolgenden Bestellungen weiter.",
    "fidelity_card_punti_regola_2_4": "Wenn Sie eine Belohnung in einer Bestellung verwenden, wird die Belohnungspunktzahl von der Summe der gesammelten Punkte abgezogen.",
    "fidelity_mask_locali_warning": "Achtung: In diesem Geschäft ({NOME_LOCALE}) können Sie keine Punkte sammeln und Prämien einlösen.",
    "fidelity_card_no_promozione": "Keine aktive Werbung",
    "fidelity_card_no_premi": "Keine Auszeichnungen verf\u00fcgbar",
    "valido_dal": "G\u00fcltig ab",
    "reward": "Prämie",
    "fidelity_card_sconto_del_1": "Rabatt von",
    "fidelity_card_sconto_del_2": "%",
    "fidelity_card_usato_ordine": "Verwendet in der Bestellung Nr.",
    "fidelity_card_usato_ordine_del": "vom",
    "fidelity_card_premi_utilizzati": "Auszeichnungen verwendet",
    "fidelity_card_premi_accumulati": "Auszeichnungen gesammelt",
    "fidelity_card_promozione_non_cumulabile": "Promotion nicht mit anderen Promotions kombinierbar.",
    "fidelity_card_punti_non_si_azzerano": "Die Punkte werden am Ende der Aktion nicht zurückgesetzt, die Punkte können jedoch mit der Aktivierung einer neuen Aktion nicht vereinbar sein, in diesem Fall werden sie zurückgesetzt.",
    "fidelity_card_punti_azzerano_1": "Die angesammelten Prämie werden auf ",
    "fidelity_card_punti_azzerano_2": "Tage nach Ablauf der Aktion zur\u00fcckgesetzt",
    "messaggi": "Nachrichten",
    "messaggistica": "Messaging",
    "messaggistica_conversazioni_attive": "Aktive Gespräche",
    "messaggistica_no_ordine_prenotazione": "Keine Bestellung oder Reservierung f\u00fcr Messaging geeignet",
    "messaggeria": "Messaging",
    "messaggistica_nessun_messaggio_disponibile": "Keine Nachricht verf\u00fcgbar",
    "valido il": "g\u00fcltig am",
    "sconto_applicato": "Rabatt angewendet",
    "premio_applicato": "Prämie angewendet",
    "indirizzo_non_modificabile": "Adresse nicht mehr bearbeitbar",
    "indirizzo_non_valido": "Ung\u00fcltige Adresse, falls diese weiterhin besteht, m\u00fcssen Sie eine neue erstellen",
    "sconto_problema_#1": "Ein Rabatt kann nicht verwendet werden, wenn eine Belohnung aktiv ist",
    "sconto_problema_#2": "Rabattcode nicht vorhanden",
    "sconto_problema_#3": "Nutzungslimit erreicht",
    "sconto_problema_#4": "Der Rabatt erfordert eine Mindestbestellmenge von",
    "rimuovi_sconto": "Rabatt entfernen",
    "seleziona_acconto": "Wählen Sie die Anzahlung",
    "usa_premio_ordine": "Verwenden Sie einen Prämie in Ihrer Bestellung",
    "seleziona_premio": "Wählen Sie den Prämie",
    "usa_premio": "Prämie verwenden",
    "premi_accumulati": "Auszeichnungen gesammelt",
    "premio": "Prämie",
    "rimuovi_premio": "Auszeichnung entfernen",
    "ore_in_data": "Stunden",
    "f_privacy_label": "* Ich habe die Datenschutzbestimmungen gelesen und bin damit einverstanden",
    "f_termini_label": "* Ich habe die Allgemeinen Nutzungsbedingungen gelesen und bin damit einverstanden",
    "f_servizi_label": "Ich bin damit einverstanden, Rabatte, Werbeaktionen, empfohlene Produkte oder Werbematerial \u00fcber die angegebene App oder E-Mail-Adresse zu senden",
    "consigliperte": "Beratung f\u00fcr Sie",
    "prodotti_suggeriti": "Vorgeschlagene Produkte",
    "password": "password",
    "confirm_remove_address": "Willst du die Adresse wirklich löschen?",
    "gratis": "Gratis",
    "limite_tempo_terminato": "Die Frist für die Durchführung des Gesprächs ist abgelaufen",
    "down_payment": "Anzahlung",
    "impossible_confirm_payment": "Zahlung kann nicht bestätigt werden",
    "label_carta_credito": "Kredit- oder Debitkarte",
    "label_titolare_carta": "Kartenhalter",
    "adds_not_availabe_with_config": "Du kannst zu diesem Produkt mit den ausgewählten Eigenschaften keine Zutaten hinzufügen.",
    "max_scelte": "max {n} choice | max {n} choices",
    "aggiunte_gratis": "kostenlose erste Ergänzung | kostenlose erste {n} Ergänzungen",
    "max_picks_reached_1": "Das ausgewählte Produkt erlaubt maximal",
    "max_picks_reached_2": "Eissorten für",
    "max_picks_reached_3": "Auswahlen.",
    "max_picks_reached_4": "Maximale Anzahl Eissorten erreicht.",
    "scegli": "Auswählen",
    "no_more_availability": "Produkt nicht verfügbar",
    "more_than_availability": "Mehr als {n} verfügbar",
    "residual_availability": "Noch verfügbar",
    "out_of_stock_single_begin": "Für dieses Produkt ist die Zutat",
    "out_of_stock_single_end": "vorübergehend nicht verfügbar. Du kannst das Produkt trotzdem bestellen und angeben, ob du stattdessen eine andere Zutat möchtest.",
    "out_of_stock_multiple_begin": "Für dieses Produkt sind die Zutaten",
    "out_of_stock_multiple_end": "vorübergehend nicht verfügbar. Du kannst das Produkt trotzdem bestellen und angeben, ob du stattdessen eine andere Zutat möchtest.",
    "min_free_picks_alert": "Du musst mindestens eingeben {n} geschmack | Du musst mindestens eingeben {n} schmeckt",
    "cambio_locale_carrello_alert": "Der Wagen wird geleert. Sind Sie sicher, dass Sie fortfahren möchten?",
    "spesa_min_indirizzo": "Die Mindestgebühr für die ausgewählte Adresse beträgt",
    "save_into_my_data": "Meine Daten speichern",
    "premio_problema_#1": "Es ist nicht möglich, einen Preis zu verwenden, wenn ein Rabatt aktiv ist",
    "cannot_select_reward_1": "Du kannst die Prämie nicht auswählen,",
    "cannot_select_reward_2": "da du kein Produkt im Warenkorb hast, für das die Prämie gilt",
    "continua_con_google": "Weiter mit Google",
    "continua_con_apple": "Weiter mit Apple",
    "scegli_come_ordinare": "Wählen Sie, wie Sie bestellen möchten",
    "scegli_zona": "Wählen Sie den Bereich",
    "scegli_locale": "Wählen Sie den Veranstaltungsort",
    "punto_consegna": "Lieferort",
    "messaggio_alert_punto_consegna": "Es ist notwendig, den Lieferpunkt einzugeben",
    "scegli_piatti": "Wählen Sie die Gerichte",
    "alert_combo_picks_min_prod": "Es muss mindestens ein Produkt eingegeben werden | Es müssen mindestens {n} Produkte eingegeben werden",
    "n_prodotti": "1 produkt | {n} produkte",
    "di_cui": "Einschließlich",
    "della_categoria": "der Kategorie {category}",
    "necessario_un_prodotto": "Es muss mindestens ein Produkt eingegeben werden",
    "soglia_minima_prodotto": "Der Mindestschwellenwert für das Produkt beträgt",
    "prezzo_fisso": "Festpreis",
    "prezzo_minimo": "Minimaler Preis",
    "nessuna_fascia_trovata": "Für diese Adresse wurde kein Zeitfenster gefunden",
    "min": "Mindest",
    "combo": "COMBO",
    "scegli_citta": "Wähle die Stadt",
    "indirizzo": "Adresse",
    "numero": "Nummer",
    "seleziona_citta": "Wählen Sie die Stadt aus",
    "removed_free_pick_alert_1": "Für dieses Produkt die Wahl | Für dieses Produkt die Auswahl",
    "removed_add_alert_1": "Für dieses Produkt der Zusatz | Für dieses Produkt die Ergänzungen",
    "removed_add_free_pick_alert_2": "ist vorübergehend nicht verfügbar und wird aus dem Produkt entfernt | sind vorübergehend nicht verfügbar und werden aus dem Produkt entfernt",
    "continuare_indirizzo": "Möchten Sie mit dieser gesuchten Adresse fortfahren?",
    "nessun_indirizzo_selezionato": "Keine Adresse ausgewählt",
    "indirizzi_fuori_zona": "Adressen außerhalb der Zone:",
    "no": "nein",
    "yes": "ja",
    "azienda": "Unternehmen",
    "privato": "Privat",
    "error_cap": "Wir konnten die Postleitzahl nicht finden. Bitte versuchen Sie es erneut mit einer anderen Adresse",
    "error_numero": "Wir konnten die Hausnummer nicht finden. Bitte versuchen Sie es erneut mit einer anderen Adresse",
    "nessuna_fascia_disponibile": "Kein Zeitfenster verfügbar",
    "nessun_metodo_selezionato": 'Keine Zahlungsmethode ausgewählt',
    "salva_carta": 'Speichern Sie Ihre Kartendaten für nächste Bestellungen',
    "aggiungi_carta": 'Fügen Sie eine Kreditkarte hinzu',
    "stato_pagamento": 'Zahlungsstatus',
    "pagamento_attesa": 'Warten auf Zahlungsbestätigung',
    "pagamento_pagato": 'Bezahlt',
    "pagamento_fallito": 'Gescheitert',
    "metodi_pagamento_title": 'Zahlungsarten',
    "aggiungi_carta_title": 'KREDITKARTE HINZUFÜGEN',
    "confirm_remove_metodo_pagamento": 'Möchten Sie die Zahlungsmethode wirklich löschen?',
    "gestisci_carte_salvate": "GESPEICHERTE KARTEN VERWALTEN",
    "scad": "Exp.",
    "attendi_attimo": "Moment mal",
    "elaborazione_pagamento": "Wir bearbeiten Ihre Zahlung",
    "nn_chiudere_browser": "Schließen Sie das Browserfenster nicht",
    "grazie": "Dankeschön",
    "spedizione_gratuita": "KOSTENLOSE LIEFERUNG",
    "coupon_spedizione_gratuita": "KOSTENLOSE LIEFERKOSTEN",
    "dil": "LIEFERUNG AUF DEM PUNKT",
    "delivery_description": "(Zuhause)",
    "dil_description": "(Lieferung ohne Adresse)",
    "sp_select": "WÄHLEN SIE EINEN SERVICEPUNKT",
    "select": "Wählen",
    "qr_scan": "QR-CODE SCANNEN",
    "qr_new_scan": "NEUEN QR-CODE SCANNEN",
    "selected_table": "AUSGEWÄHLTE TABELLE",
    "inserisci_indirizzo": 'ADRESSE EINGEBEN',
    "msg_nussun_ristorante": "Die eingegebene Adresse wird von keinem Restaurant bedient. Bitte geben Sie eine neue Adresse ein und versuchen Sie es erneut.",
    "msg_inserisci_indirizzo": "Geben Sie die Lieferadresse ein, um die Restaurants in Ihrer Nähe anzuzeigen, die den Service anbieten.",
    "trovami": "Finde mich",
    "label_indirizzo_consegna": "LIEFERADRESSE",
    "label_indirizzo_salvato": "ODER WÄHLEN SIE EINE GESPEICHERTE ADRESSE",
    "sconti_non_applicabili": "Rabatte nicht anwendbar",
    "variante_obbligatoria_alert": "Achtung, Sie müssen eine Auswahl für das Feld: {etichetta} treffen",
    "min_aggiunte_necessarie_sing": "Es ist erforderlich, mindestens den Zusatz {MIN_AGGIUNTE} der Gruppe {GRUPPO} einzugeben",
    "min_aggiunte_necessarie_plur": "Es ist notwendig, mindestens {MIN_AGGIUNTE} Ergänzungen der Gruppe {GRUPPO} einzugeben",
    "racer_ready": "Lieferbereit",
    "racer_assigned": "Auftrag dem Rennfahrer zugewiesen",
    "racer_on_delivery": "Bestellung unterwegs",
    "racer_delivered": "Geliefert",
    "racer_undeliverable": "Wir konnten Ihre Bestellung nicht liefern",
    "racer_cancelled": "Lieferung wurde storniert",
    "attivo_solo_per": "Aktiv nur für",
    "coupon_non_utilizzabile": "Rabattcode für diese Bestellart nicht verwendbar",

    /* NUOVI TESTI 2026 */
    "feedback": "Feedback",
    "feedback_invia": "Feedback senden",
    "feedback_intro_text": "Ihre Meinung ist sehr wichtig, um unseren Service zu verbessern.",
    "feedback_intro_completed_text": "Wir danken Ihnen für die Zeit, die Sie uns gewidmet haben. Ihre Vorschläge sind immer wertvoll und tragen dazu bei, unseren Service immer weiter zu verbessern!",
    "feedback_non_disponibile": "Feedback nicht verfügbar",
    "feedback_no_questions": "Keine Fragen verfügbar",
    "feedback_domande_incomplete": "Bitte beantworten Sie vor dem Senden alle Fragen",
    "feedback_inviato_successo": "Danke, Ihr Feedback wurde gesendet!",
    "feedback_inviato_il": "Gesendet am",
    "feedback_ordine_numero": "Bestellung Nr.",
    "riordina": "Neu ordnen",
    "ordina": "Bestellen",
    "codici_sconto": "Rabattcodes",
    "fidelity": "Fidelity",
    "card": "Karte",
    "invia_sondaggio": "Umfrage senden",
    "sondaggio_completato": "Umfrage abgeschlossen",
    "sondaggio_rispondi": "Beantworten Sie die Fragen",
    "sondaggio_login_title": "Melden Sie sich an, um die Umfrage auszufüllen",
    "sondaggio_login_description": "Bitte melden Sie sich an, um die Fragen zu beantworten und ggf. einen Rabattcode zu erhalten.",
    "sondaggio_non_disponibile": "Umfrage nicht verfügbar",
    "sondaggio_completed_intro": "Die Umfrage wurde abgeschlossen!",
    "sondaggio_completed_coupon_available": "Hier ist Ihr Rabattcode:",
    "sondaggio_completed_coupon_hint": "Sie erhalten ihn auch per E-Mail (sehen Sie bitte auch im Spam-Ordner nach) und zusätzlich finden Sie ihn im Bereich Rabattcodes der App.",
    "sondaggio_completed_coupon_used": "Sie haben diesen Rabattcode bereits bei einer Bestellung verwendet.",
    "sondaggio_completed_thanks": "Vielen Dank, Ihre Vorschläge helfen uns, den Service zu verbessern.",
    "inserisci_codice": "Geben Sie den Code ein",
    "inserisci_codice_oppure": "oder klicken Sie auf einen der unten aufgeführten Codes",


}
